import React from 'react';
import { useParams } from 'react-router-dom';
import JobApplicationsView from './JobApplicationsView';

const JobApplicationsViewWrapper = () => {
  const { userId } = useParams<{ userId: string }>();
  return <JobApplicationsView userId={userId ? parseInt(userId) : undefined} />;
};

export default JobApplicationsViewWrapper;